// extracted by mini-css-extract-plugin
export default {"container":"MonthStat_container__6td8g","header":"MonthStat_header__A51tK","legend":"MonthStat_legend__cEF5d"};